<div *ngIf="loading" class="spinner-overlay">
    <p-progressSpinner  diameter="50"></p-progressSpinner >
 </div>